import React, { FC, useState } from 'react';

// Component to preview UnknownStory content (video or image)
const UnknownStoryPreview: FC<{ url: string }> = ({ url }) => {
  const [errored, setErrored] = useState(false);

  if (!errored) {
    return (
      <div style={containerStyle}>
        <video
          src={url}
          autoPlay
          muted
          loop
          style={{ maxWidth: '100%', borderRadius: 8, marginTop: 8 }}
          onError={() => setErrored(true)}
        />
        <div style={watermarkStyle}>24h story</div>
      </div>
    );
  }

  // If video fails, try image
  return (
    <div style={containerStyle}>
      <img
        src={url}
        alt="media preview"
        style={{ maxWidth: '100%', borderRadius: 8, marginTop: 8 }}
        onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }}
      />
      <div style={watermarkStyle}>24h story</div>
    </div>
  );
};

// Watermark overlay style
const watermarkStyle: React.CSSProperties = {
  position: 'absolute',
  top: 12,
  left: 12,
  background: 'rgba(0,0,0,0.55)',
  color: '#fff',
  padding: '4px 14px',
  borderRadius: 16,
  fontWeight: 700,
  fontSize: 16,
  letterSpacing: 1,
  zIndex: 2,
  pointerEvents: 'none',
  boxShadow: '0 2px 8px #0003',
  userSelect: 'none',
};

// Container style for positioning watermark
const containerStyle: React.CSSProperties = {
  position: 'relative',
  display: 'inline-block',
  width: '100%',
};

export default UnknownStoryPreview;
